/* eslint-disable react/button-has-type */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { FC, Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Headline, Body } from '@airwallex/typography';
import { LinkInfoData } from './types';
import {
  bannerContainerCss,
  imgContainerCss,
  imgCss,
  headCss,
  headerCss,
  bodyCss,
  reloadAndBackBtnCss,
  bannerLogoContainerCss,
  bannerLogoCss,
  logoImgBasicCss,
  primaryBtnCss,
} from './styles';
import LockForPBL from '@/assets/svgs/lockForPBL.svg';
import Success from '@/assets/svgs/success.svg';
import Error from '@/assets/svgs/error.svg';
import { event, Category, Action, Label } from '@/utils/analytics/google';

// PAID only for one-time
type Status = 'EXPIRED' | 'PAID' | 'ERROR' | 'DISABLED';
export const STATUS_IMG: Record<Status, string> = {
  EXPIRED: LockForPBL,
  DISABLED: LockForPBL,
  PAID: Success,
  ERROR: Error,
};

type Props = {
  linkInfo?: LinkInfoData;
  hasError?: boolean;
  intentNotPaid?: boolean;
};

const Index: FC<Props> = ({ linkInfo, hasError, intentNotPaid }) => {
  const { t } = useTranslation();

  const handleClick = useCallback((label: Label) => {
    event(Category.PrePaymentFailPage, Action.Click, label);
    window.location.reload();
  }, []);

  const LinkInfoStatusImg = STATUS_IMG[linkInfo?.status as Status];

  if (hasError || intentNotPaid) {
    return (
      <Fragment>
        <div css={bannerContainerCss} />
        <div css={imgContainerCss()}>
          <STATUS_IMG.ERROR css={imgCss()} />
        </div>
        {hasError && (
          <div css={headCss}>
            <Headline variant="100" css={headerCss}>
              {t('checkout.error.something_went_wrong')}
            </Headline>
            <Body css={bodyCss}>{t('checkout.error.reload_page')}</Body>
            <button onClick={() => handleClick(Label.Reload)} css={reloadAndBackBtnCss}>
              {t('pay_by_link.error.button.reload_page')}
            </button>
          </div>
        )}
        {intentNotPaid && (
          <div css={headCss}>
            <Headline variant="100" css={headerCss}>
              {t('pay_by_link.fail.title')}
            </Headline>
            <Body css={bodyCss}>{t('pay_by_link.fail.description')}</Body>
            <button onClick={() => handleClick(Label.TryAgain)} css={primaryBtnCss}>
              {t('pay_by_link.fail.try_again')}
            </button>
          </div>
        )}
      </Fragment>
    );
  }
  return (
    <div css={bannerContainerCss}>
      <div css={imgContainerCss(linkInfo)}>
        <LinkInfoStatusImg css={imgCss(linkInfo)} />
      </div>
      <div css={headCss}>
        <Headline variant="100" css={headerCss}>
          {t(`pay_by_link.${linkInfo?.status?.toLowerCase()}.head`)}
        </Headline>
        <Body css={bodyCss}>{t(`pay_by_link.${linkInfo?.status?.toLowerCase()}.description`)}</Body>
      </div>
      {linkInfo?.logoUrl && (
        <div css={bannerLogoContainerCss}>
          <div css={bannerLogoCss}>
            <img css={logoImgBasicCss} src={linkInfo?.logoUrl} alt="logo-icon" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
